import _extends from "@babel/runtime/helpers/extends";

/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../internal'; // eslint-disable-next-line react/display-name

var IconComponent = React.forwardRef(function (props, ref) {
  return React.createElement("svg", _extends({}, props, {
    ref: ref,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), React.createElement("g", {
    id: "16x16/fast_service"
  }, React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 3C0 1.34315 1.34315 0 3 0H13C14.6569 0 16 1.34315 16 3V13C16 14.6569 14.6569 16 13 16H3C1.34315 16 0 14.6569 0 13V3ZM3 2C2.44772 2 2 2.44772 2 3V13C2 13.5523 2.44772 14 3 14H13C13.5523 14 14 13.5523 14 13V3C14 2.44772 13.5523 2 13 2H3ZM10.8808 8.84003C10.9584 8.57348 11 8.2916 11 8C11 6.34315 9.65685 5 8 5C7.42678 5 6.89111 5.16077 6.43562 5.43967C6.66509 5.53355 6.88141 5.64069 7.08656 5.75934C7.87637 6.21609 8.44937 6.81722 8.91704 7.31606L8.96989 7.37246C9.43709 7.87106 9.7915 8.24929 10.2344 8.53273C10.4228 8.65335 10.6332 8.75951 10.8808 8.84003ZM9.6597 10.4995C9.18438 10.8157 8.61371 11 8 11C6.34315 11 5 9.65685 5 8C5 7.6931 5.04608 7.39696 5.13171 7.11812C5.51337 7.20663 5.82197 7.33837 6.08531 7.49066C6.59238 7.78391 6.98813 8.18278 7.45796 8.68394L7.5545 8.78718C7.98001 9.24279 8.49464 9.79384 9.15626 10.2173C9.31654 10.3198 9.48395 10.4143 9.6597 10.4995ZM8 13C10.7614 13 13 10.7614 13 8C13 5.23858 10.7614 3 8 3C5.23858 3 3 5.23858 3 8C3 10.7614 5.23858 13 8 13Z",
    fill: "currentColor"
  })));
});
/**
 * Компоненты иконки <br />
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.<br />
 * Подключение иконки: `import { FastService16 } from '@cian/ui-kit/icons';`, <br />
 * где 16 - это размер иконки в пикселях.
 */

export var FastService16 = createIcon(IconComponent);